import { useContext, useState } from "react";
import { AuthContext } from "../../context/authContext";
import CreatePage from "../../pages/create/CreatePage";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import imageCompression from "browser-image-compression";
import { db } from "../../matabase";
import {
  collection,
  addDoc,
  updateDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";

const Create = () => {
  const { currentUser } = useContext(AuthContext);
  const state = useLocation().state;
  const [img, setImg] = useState(state?.img || "");
  const [value, setValue] = useState(state?.desc || "");
  const [title, setTitle] = useState(state?.title || "");
  const [url, setUrl] = useState(state?.vid || "");
  const [cat, setCat] = useState(state?.cat || "");
  const [top, setTop] = useState(state?.top || "no");
  const [date, setDate] = useState(state?.date || serverTimestamp());
  const navigate = useNavigate();
  const [load, setLoad] = useState(false);
  const [err, setErr] = useState(null);
  const handleFileChange = async (e) => {
    setLoad(true);
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      try {
        const options = {
          maxSizeMB: 0.1,
          maxWidthOrHeight: 800,
          useWebWorker: true,
        };

        const compressedFile = await imageCompression(selectedFile, options);
        const reader = new FileReader();
        reader.readAsDataURL(compressedFile);
        reader.onloadend = () => {
          setImg(reader.result); // use state
          console.log(img);
          setLoad(false);
        };
      } catch (error) {
        setLoad(false);
        setErr("Something went wrong");
        console.error("Error compressing the image:", error);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoad(true);

    if (!state) {
      try {
        const res = await addDoc(collection(db, "posts"), {
          title,
          desc: value,
          cat,
          img,
          top,
          vid: url,
          uid: currentUser.uid,
          date,
        });
        console.log(res.id);
        navigate(`/post/${res.id}`);
      } catch (error) {
        console.log(error.message);
        setErr("Something went wrong");
      }
    } else {
      try {
        const postRef = doc(db, "posts", state?.postId); // document reference
        await updateDoc(postRef, {
          title,
          desc: value,
          cat,
          top,
          img,
          vid: url,
          uid: currentUser.uid,
          date,
        });

        console.log("Updated:", state?.postId);
        navigate(`/post/${state?.postId}`);
      } catch (error) {
        console.log(error.message);
        setErr("Something went wrong");
      }
    }
    setLoad(false);
  };

  if (!currentUser) {
    return <Navigate to={"/"} />;
  }

  return (
    <div>
      {load ? (
        <p className="load-err">Loading...</p>
      ) : (
        <CreatePage
          handleSubmit={handleSubmit}
          value={value}
          setValue={setValue}
          title={title}
          setTitle={setTitle}
          cat={cat}
          top={top}
          setCat={setCat}
          setTop={setTop}
          handleFileChange={handleFileChange}
          img={img}
          err={err}
          url={url}
          setUrl={setUrl}
        />
      )}
    </div>
  );
};

export default Create;
